"use client"

import { useOurContext } from "@/context/dot-field.context"

import { MarkdownRender } from "@repo/ui/components/markdown-render/index"

import { PageContainerInner } from "@/components/page-container-inner/page-container-inner"
import { PageContainer } from "@/components/page-container/page-container"
import { PageTitle } from "@/components/page-title/page-title"

import { useEffect } from "react"

import styles from "./page.module.css"

const md = `
#### Get in Touch 
If you're a member of the media and would like to talk, please send an email to [press@agency.inc](mailto:press@agency.inc). 

#### Agency Press Kit
Our [press kit](https://drive.google.com/drive/folders/1HOOdh8zd54tMglOg3E05Enx3M5ZjJVFN?usp=sharing) includes the latest logos, product images, leadership headshots, bios, and boilerplate. 

#### About Agency
Agency is an AI agent for customer success teams. The seed-stage company is backed by Sequoia Capital. For more information, visit agency.inc

#### About Founder and CEO Elias Torres
Elias Torres is the founder and CEO of Agency—an AI agent for customer success teams. Agency is backed by Sequoia Capital.

Before Agency, Elias co-founded Drift, a groundbreaking digital experience platform that revolutionized B2B transactions and created the Conversational Marketing category. Drift's acquisition by Vista Equity Partners in 2021, valued at over $1 billion, made it one of the less than 1% of unicorns led by Latino founders.

Elias has held leadership roles at HubSpot, a public inbound marketing company and Performable, a software platform for businesses that was acquired by HubSpot. When he was the VP of engineering at Lookery, Elias built a cloud-based ad targeting platform. He began his career with IBM as a software engineer for 10 years working with an amazing team of technical visionaries.

Elias is a Nicaraguan-born entrepreneur and philanthropist. Raised by a hard-working single mother instilled in Elias an indomitable mindset as well as compassion for others. Elias is deeply committed to fostering Latino and immigrant-led entrepreneurship in the U.S. and launched "The American Dream with Elias Torres" podcast as a part of that work. A graduate of the University of South Florida and Harvard University, Elias is also a Henry Crown Fellow of the Aspen Institute. Elias resides in Belmont, Massachusetts, with his wife Alejandra, three children, and their beloved dog, Baloo.
`

const pressLinks = [
  {
    org: "New York Times",
    title: "AI Silicon Valley Start-ups",
    url: "https://www.nytimes.com/2025/02/20/technology/ai-silicon-valley-start-ups.html"
  },
  {
    org: "20VC",
    title:
      "Selling Drift for $1.2BN is the Biggest Failure: What No One Tells You About Selling Your Company | Why Incumbents Are Slower & Worse Than Ever",
    url: "https://open.spotify.com/episode/033kh70JKE3IDOjKCKfiDo"
  },
  {
    org: "TechCrunch",
    title: "After selling Drift, ex-HubSpot exec launches AI for customer success managers",
    url: "https://techcrunch.com/2024/10/16/after-selling-drift-ex-hubspot-exec-launches-ai-for-customer-success-managers/"
  },
  {
    org: "No Priors",
    title: "Revolutionizing Customer Success with Agency's Elias Torres",
    url: "https://podcasts.apple.com/us/podcast/revolutionizing-customer-success-with-agencys-elias/id1668002688"
  },
  {
    org: "Marketing AI Institute",
    title: "The AI Show Episode 120",
    url: "https://www.marketingaiinstitute.com/blog/the-ai-show-episode-120"
  },
  {
    org: "Superhuman AI: Decoding the Future",
    title: "5 pieces of advice from a billion dollar AI startup founder",
    url: "https://open.spotify.com/episode/1yET7sR27KDm3U2NNdCaZ5"
  },
  {
    org: "CHURN FM",
    title: "Redefining Customer Success in the Age of AI",
    url: "https://open.spotify.com/episode/0fThuRretJxOVH7yNq6ibO"
  },
  {
    org: "Boston Business Journal",
    title: "Drift co-founder launches new AI startup",
    url: "https://www.bizjournals.com/boston/news/2024/10/17/elias-torres-drift-ai-agency.html"
  },
  {
    org: "This is Growth!",
    title: "How Al is Transforming CS",
    url: "https://open.spotify.com/episode/6gOYAGl4nOjFBC3OmxEchM"
  }
]

export default function Home() {
  const { setDotFieldIndex } = useOurContext()

  useEffect(() => {
    setDotFieldIndex("random")
  }, [setDotFieldIndex])

  return (
    <PageContainer>
      <PageContainerInner>
        <PageTitle
          subtitle="Read and hear how Agency is making waves around the AI world and beyond:"
          title="Press"
        />
        <ul className={styles["pressLinks"]}>
          {pressLinks.map(link => (
            <li key={link.url}>
              <a href={link.url} rel="noopener noreferrer" target="_blank">
                <strong>{link.org}</strong> - <span className={styles["title"]}>{link.title}</span>
              </a>
            </li>
          ))}
        </ul>
        <div className="flex flex-col justify-center gap-10">
          <MarkdownRender
            className="max-w-full"
            content={md}
            isStreaming={false}
            customComponents={{
              a: ({ children, ...props }) => (
                <a
                  {...props}
                  className="!text-primary !underline"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {children}
                </a>
              )
            }}
          />
        </div>
      </PageContainerInner>
    </PageContainer>
  )
}
